import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { HttpClient } from '@angular/common/http';
import {EventEmitter, Injectable} from '@angular/core';
import { UserTask } from '../../interfaces/user-task.interface';
import { Observable } from 'rxjs';
import FormVariablesUtils
  from "../../../../submodules/sellions_forms/projects/forms/src/lib/utils/form-variables-utils";
import {
  FormVariables
} from "../../../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-variables.interface";

@Injectable()
export class UserTaskService {
  public reloadUserTaskListEventEmitter;
  constructor(private configService: ConfigServiceProvider, private http: HttpClient) {
    this.reloadUserTaskListEventEmitter = new EventEmitter();
  }

  public get(id: string): Observable<UserTask> {
    return this.http.get<UserTask>(this.configService.getEngineUrl('userTask').replace('{id}', id.toString()));
  }

  public complete(id: string, formVariables: FormVariables): Observable<any> {
    const formData = new FormData();
    formVariables.multipartFiles.forEach((multipartFile) => formData.append('multipartFiles', multipartFile.file, multipartFile.fileNameWithPath));
    formData.append('variables', FormVariablesUtils.getBlob(formVariables.variables));

    return this.http.post(this.configService.getEngineUrl('completeUserTask').replace('{id}', id.toString()), formData);
  }

  public claim(id: string): Observable<any> {
    return this.http.post<UserTask>(this.configService.getEngineUrl('claimUserTask').replace('{id}', id.toString()), {});
  }
}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/services/user-task.service/user-task.service.ts